import { FormControl, Validators } from '@angular/forms';
import { FormConfig } from 'ngx-eo-web-components';
import { amkaValidator } from '../../validators/amka.validator';
import { afmValidator } from '../../validators/afm.validator';
import { af } from 'date-fns/locale';

export const gsisOAuth2FormConfig: FormConfig = new FormConfig({
  config: [
    {
      name: 'afm',
      control: new FormControl('', [Validators.required, afmValidator()]),
      errors: {
        required: 'Το Α.Φ.Μ. είναι υποχρεωτικό',
        afm: 'Το Α.Φ.Μ. δεν είναι έγκυρο'
      },
    },
    {
      name: 'amka',
      control: new FormControl('', [Validators.required, amkaValidator()]),
      errors: {
        required: 'Το Α.Μ.Κ.Α. είναι υποχρεωτικό',
        amka: 'Το Α.Μ.Κ.Α. δεν είναι έγκυρο'
      },
    },
  ],
});
